import {
  Card,
  FormattedMessageDiv,
  FormattedNumberDiv,
  Tooltip,
} from '@odmonorepo/core-components';
import { Stack } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';

export const LOCCostsAndFees = ({ offer, checkout }) => {
  return (
    <Card
      className="bg-light-gray shadow-none"
      bodyClassName="p-md-5 px-md-6 p-4"
    >
      <Stack gap={3}>
        <FormattedMessageDiv
          className="fw-bold fs-5 text-start"
          id="offerPreview.costAndFees"
        />
        <Stack direction="horizontal">
          <FormattedMessageDiv id="offerReview.monthlyFee" />
          <FormattedNumberDiv
            value={offer.pricedDetails.monthlyFee}
            style="currency"
            currency="USD"
            className="ms-auto"
          />
        </Stack>
        <Stack direction="horizontal">
          <FormattedMessageDiv id="offerPreview.originationFee" />
          <FormattedNumberDiv
            value={offer.pricedDetails.loanOriginationFee}
            style="currency"
            currency="USD"
            className="ms-auto"
          />
        </Stack>
        <Stack direction="horizontal" className="align-items-end">
          <FormattedMessageDiv id="offerReview.returnedPaymentFee" />
          <FormattedNumberDiv
            value={offer.returnedPaymentFee}
            style="currency"
            currency="USD"
            className="ms-auto"
          />
        </Stack>
        <Stack direction="horizontal">
          <FormattedMessageDiv id="offerReview.lateFee" />
          <FormattedNumberDiv
            value={offer.lateFee}
            style="currency"
            currency="USD"
            className="ms-auto"
          />
        </Stack>
        {!checkout ? (
          <Stack direction="horizontal" className="align-items-end">
            <FormattedMessageDiv id="offerPreview.paymentFrequency" />
            <div className="ms-auto">
              {offer.pricedDetails.paymentFrequency.toUpperCase() === 'WEEKLY'
                ? 'Weekly'
                : 'Monthly'}
            </div>
          </Stack>
        ) : null}
      </Stack>
    </Card>
  );
};
